/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_History_MoreInputs */

const en_us2_exercise_sheet_history_more = /** @type {(inputs: Exercise_Sheet_History_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show earlier workouts`)
};

const pt_br2_exercise_sheet_history_more = /** @type {(inputs: Exercise_Sheet_History_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver treinos anteriores`)
};

const es_419_exercise_sheet_history_more = /** @type {(inputs: Exercise_Sheet_History_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver entrenamientos anteriores`)
};

const pt_pt2_exercise_sheet_history_more = /** @type {(inputs: Exercise_Sheet_History_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver treinos anteriores`)
};

const fr_fr2_exercise_sheet_history_more = /** @type {(inputs: Exercise_Sheet_History_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir les séances précédentes`)
};

const de_de2_exercise_sheet_history_more = /** @type {(inputs: Exercise_Sheet_History_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frühere Trainings anzeigen`)
};

const it_it2_exercise_sheet_history_more = /** @type {(inputs: Exercise_Sheet_History_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra allenamenti precedenti`)
};

/**
* | output |
* | --- |
* | "Show earlier workouts" |
*
* @param {Exercise_Sheet_History_MoreInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_history_more = /** @type {((inputs?: Exercise_Sheet_History_MoreInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_History_MoreInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_history_more(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_history_more(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_history_more(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_history_more(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_history_more(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_history_more(inputs)
	return en_us2_exercise_sheet_history_more(inputs)
});
export { exercise_sheet_history_more as "exercise-sheet.history_more" }